<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Is there a chance I could get less money?<Caret /></summary>
  <p>
    No. If you counter, there’s no risk of you getting less than this offer. You will either get the same offer or,
    ideally, a higher offer.
  </p>
</details>
